<div
  class="relative flex w-fit cursor-pointer gap-2 rounded-full border p-1 px-3 text-lg"
  [ngClass]="{
    'border-[rgba(75,142,207,0.30)] bg-[#F3F7FC] text-[#2D6BA9]': isChecked(),
  }">
  @if (isChecked()) {
    <span class="material-symbols-rounded">check</span>
  }
  <span>{{ text() }}</span>
</div>
